import AuthHelper from "components/auth/helpers";
import { Redirect } from "react-router";
import { ApiURLType } from "utils/Types";

export const ErrorToLogout: React.FC<{ path: ApiURLType }> = ({ path }) => {
  AuthHelper.clearAuth();

  return <Redirect to={path} />;
};

export default ErrorToLogout;
